/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */

import _ from 'lodash';
import {capitalize, lowercaseFirstWord} from './stringHelper';

function checkIsPassedCondition(objectValue, condition) {
  let passedCondition = true;

  if (typeof condition === 'function') {
    return condition(objectValue);
    // eslint-disable-next-line no-else-return
  } else {
    for (const conditionKey in condition) {
      if (Array.isArray(condition[conditionKey])) {
        passedCondition = false;
        for (const arraykey in condition[conditionKey]) {
          if (objectValue[conditionKey] === condition[conditionKey][arraykey]) {
            passedCondition = true;
            break;
          }
        }
      } else if (objectValue[conditionKey] !== condition[conditionKey]) {
        passedCondition = false;
        break;
      }
    }
  }

  return passedCondition;
}

export function filter(object, condition) {
  const result = {};

  for (const key in object) {
    if (checkIsPassedCondition(object[key], condition)) {
      result[key] = object[key];
    }
  }

  return result;
}

export function filterToArray(object, condition) {
  const result = [];

  for (const key in object) {
    if (checkIsPassedCondition(object[key], condition)) {
      result.push(object[key]);
    }
  }

  return result;
}

export function find(object, condition) {
  let result;
  for (const key in object) {
    if (checkIsPassedCondition(object[key], condition)) {
      result = object[key];
      break;
    }
  }
  return result;
}

export function findLast(object, condition) {
  let result;
  const keys = Object.keys(object);
  for (let index = keys.length - 1; index >= 0; index -= 1) {
    const key = keys[index];
    if (checkIsPassedCondition(object[key], condition)) {
      result = object[key];
      break;
    }
  }
  return result;
}

export function findKeyByValue(object, condition) {
  return Object.keys(object).find((key) => checkIsPassedCondition(object[key], condition));
}

export function isEmpty(object) {
  return !object || !Object.keys(object).length;
}

export function reorderID(object) {
  const result = {};
  for (const key in object) {
    result[key] = {...object[key], ID: parseInt(key, 10)};
  }
  return result;
}

export const selectDistinct = (arr) => {
  if (!arr || !arr.length) {
    return [];
  }

  const onlyUnique = (value, index, self) => self.indexOf(value) === index;

  return arr.filter(onlyUnique);
};

export const insertAndRearrange = (object, startID, newItemIds = []) => {
  const result = {};
  const dictionaryID = {}; // { oldID: newID }
  let key = 0;

  // insert new items before first item
  if (startID < 0) {
    newItemIds.forEach((newID) => {
      const newItem = object[newID];
      result[key] = {...newItem, ID: parseInt(key, 10)};
      dictionaryID[newItem.ID] = key;
      key += 1;
    });
  }

  Object.values(object).forEach((item) => {
    if (!newItemIds.includes(item.ID)) {
      result[key] = {...item, ID: parseInt(key, 10)};
      dictionaryID[item.ID] = key;

      // insert new items
      if (startID === item.ID) {
        newItemIds.forEach((newID) => {
          const newItem = object[newID];
          key += 1;
          result[key] = {...newItem, ID: parseInt(key, 10)};
          dictionaryID[newItem?.ID] = key;
        });
      }

      key += 1;
    }
  });

  return [result, dictionaryID];
};

export const bulkInsertAfterCertainID = (dataToInsert, objects, returnIdAlso = false) => {
  /* dataToInsert = {id: data, id: data, id: data, ... } */
  const allObjectIds = Object.values(objects)
    .map((c) => c.ID)
    .reverse();
  const idToInsertAfter = Object.keys(dataToInsert);
  let incrementer = 0;
  Object.values(dataToInsert).forEach((d) => {
    if (Array.isArray(d)) {
      incrementer += d.length;
    } else {
      incrementer += 1;
    }
  });
  let biggestId = idToInsertAfter.pop();
  const idOfInsertedData = [];

  const newObject = {};
  allObjectIds.forEach((id) => {
    const idNumber = parseInt(id, 10);
    if (idNumber > biggestId) {
      newObject[idNumber + incrementer] = {...objects[id], ID: idNumber + incrementer};
    } else {
      const insertedData = dataToInsert[idNumber];
      if (Array.isArray(insertedData)) {
        const reversedInsertData = insertedData.reverse();
        reversedInsertData.forEach((dt) => {
          newObject[idNumber + incrementer] = {...dt, ID: idNumber + incrementer};
          idOfInsertedData.push(idNumber + incrementer);
          incrementer -= 1;
        });
      } else {
        newObject[idNumber + incrementer] = {...insertedData, ID: idNumber + incrementer};
        idOfInsertedData.push(idNumber + incrementer);
        incrementer -= 1;
      }
      biggestId = idToInsertAfter.pop();
      if (biggestId === null || biggestId === undefined) biggestId = -1;
      newObject[idNumber + incrementer] = {...objects[id], ID: idNumber + incrementer};
    }
  });
  if (returnIdAlso) {
    return [newObject, idOfInsertedData];
  }
  return newObject;
};

export const getObjectIdsInBetween = (startID, endID, objects) => {
  const keys = Object.keys(objects);
  let startIndex = keys.indexOf(startID.toString());
  let endIndex = keys.indexOf(endID.toString());

  if (startIndex > endIndex) {
    [startIndex, endIndex] = [endIndex, startIndex];
  }

  const selectedIds = [];
  for (let i = startIndex; i <= endIndex; i += 1) {
    const currentCardID = keys[i];
    selectedIds.push(currentCardID);
  }

  return selectedIds;
};

export const convertObjectToStringCSS = (dataObj, withImportant) => {
  let cssResult = '';

  Object.keys(dataObj).forEach((propertyKey) => {
    const propertyNameWithHyphens = propertyKey
      .split(/(?=[A-Z])/g)
      .join('-')
      .toLowerCase();
    cssResult += `${propertyNameWithHyphens}: ${dataObj[propertyKey]} ${withImportant ? '!important' : ''};`;
  });

  return cssResult;
};

export const modifyObjectValue = (oldObject, fieldName, newFieldValue) => {
  let newObject = {};

  if (oldObject[fieldName]) {
    newObject = {
      ...oldObject,
      [fieldName]: {
        ...oldObject[fieldName],
        ...newFieldValue,
      },
    };
  }

  return newObject;
};

export const cloneAndMapObject = (objectToMap, properties, isMapNonExistentKey) => {
  const clonedObject = _.cloneDeep(objectToMap);
  let newObject = {};

  for (const key of properties) {
    if (Object.prototype.hasOwnProperty.call(objectToMap, key)) {
      newObject = {...newObject, [key]: clonedObject[key]};
    } else if (isMapNonExistentKey) {
      newObject = {...newObject, [key]: undefined};
    }
  }

  return newObject;
};

/**
 * clone and map object to specified properties object with data types. If the object does not have
 * a property, a default value will be created with the defined data types
 * @param {Object} objectToMap object to be mapped
 * @param {Object} propertiesWithDataTypes an object of key-values properties with data types. { propertiesKey: dataTypes }, ex: { ID: Number }
 * @param {Boolean} isMapNonExistentKey fill empty value?
 * @returns {Object} mapped object
 */
export const cloneAndMapObjectWithDataTypes = (objectToMap, propertiesWithDataTypes, isMapNonExistentKey) => {
  if (_.isEmpty(propertiesWithDataTypes)) return objectToMap;

  const clonedObject = _.cloneDeep(objectToMap);
  const properties = Object.entries(propertiesWithDataTypes);

  let newObject = {};

  for (const prop of properties) {
    const [key, defaultValueType] = prop;
    const isDataTypeAFunc = typeof defaultValueType === 'function';

    if (Object.prototype.hasOwnProperty.call(objectToMap, key)) {
      newObject = {...newObject, [key]: isDataTypeAFunc ? defaultValueType(clonedObject[key]) : clonedObject[key]};
    } else if (isMapNonExistentKey) {
      newObject = {...newObject, [key]: isDataTypeAFunc ? defaultValueType() : undefined};
    }
  }

  return newObject;
};

export const capitalizeEveryKeysFirstWord = (obj) => {
  let newObject = {};

  for (const [key, value] of Object.entries(obj)) {
    newObject = {...newObject, [capitalize(key)]: value};
  }

  return newObject;
};

export const lowercaseEveryKeysFirstWord = (obj) => {
  let newObject = {};

  for (const [key, value] of Object.entries(obj)) {
    newObject = {...newObject, [lowercaseFirstWord(key)]: value};
  }

  return newObject;
};

export const replaceIDandKey = (object, oldID, newID, opt = {IDKeyName: 'ID', keepOccupiedNewID: false}) => {
  if (_.isEmpty(object)) return object;

  const {IDKeyName, keepOccupiedNewID} = opt;
  const updatedObject = {...object};

  const oldIDonObject = object[`*${oldID}`] ? `*${oldID}` : oldID;
  const oldValueTemp = object[oldIDonObject];

  const newIDValue = object[newID];
  const isDifferentID = Number(oldID) !== Number(newID);

  if (newIDValue && keepOccupiedNewID && isDifferentID) {
    // the target ID has already been occupied, add a flag so it wouldn't get overwritten
    updatedObject[`*${newID}`] = {...newIDValue, [IDKeyName]: `*${newID}`};
  }

  delete updatedObject[oldIDonObject];
  updatedObject[newID] = {...oldValueTemp, [IDKeyName]: newID};

  return updatedObject;
};

/**
 * Find object values through keys.
 * @param {Array} array array with object's keys
 * @param {Object} objectToCompare object that possibly has a key that matches with array's element(s)
 * @returns {Array} array of matching object values
 */
export const findObjectValueByKeys = (array, objectToCompare) => {
  if (!array) return [];

  const result = [];

  for (let i = 0; i < array.length; i += 1) {
    const value = array[i];

    if (objectToCompare[value]) {
      result.push(objectToCompare[value]);
    }
  }

  return result;
};

/**
 * Find object values through keys and exclude them from the object
 * @param {Object} objectToCompare object that possibly has a key that matches with array's element(s)
 * @param {Array} array array with object's keys
 * @returns {Oject} array of matching object's values and object without the excluded keys
 */
export const findAndExcludeObjectValueByKeys = (objectToCompare, array) => {
  const result = [];
  const excluded = {...objectToCompare};

  for (let i = 0; i < array.length; i += 1) {
    const key = array[i];

    if (objectToCompare[key]) {
      result.push(objectToCompare[key]);
      delete excluded[key];
    }
  }

  return {found: result, excluded};
};

/**
 * Iterate through object and map the callback return value into an object
 * @param {Object} obj object to iterate
 * @param {func} callback function that returns another object
 * @returns {Oject} object result from callback
 */
export const mapObject = (obj, callback = () => {}) => {
  if (!obj) return {};

  let newObject = {};

  Object.entries(obj).forEach((keyVal, index) => {
    const key = keyVal[0];
    const val = keyVal[1];

    newObject = {...newObject, ...callback(val, key, index)};
  });

  return newObject;
};
